export default __webpack_public_path__ + "static/media/room-toxic-illustration.431ce63a.png";